import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, notification } from "antd";
import { withRouter } from "react-router";
import { getPriorArtByPatent } from "../../../services/api-pqai";
import { isEmpty } from "lodash";

const formatUcid = pubId => {
  const match = pubId.match(/^(US)(\d+)(.*)/);

  return match ? `${match[1]}-${match[2]}-${match[3]}` : undefined;
};

class PriorArtLink extends Component {
  static propTypes = {
    value: PropTypes.string
  };

  state = {
    loading: false
  };

  render() {
    const { loading } = this.state;
    return (
      <Button onClick={this._onSearch} loading={loading} type={"primary"} style={{ marginLeft: 5 }}>
        {"Find Prior Art"}
      </Button>
    );
  }

  _onSearch = () => {
    this.setState({ loading: true });
    const pn = this.props.value.replace(/-/g, "");

    getPriorArtByPatent(pn, 50)
      .then(results => {
        const ucids = results.map(result => formatUcid(result.publication_id)).filter(x => !isEmpty(x));
        this.props.router.push({
          pathname: "/patents/search",
          query: { ucid_spif: ucids.join("\n") }
        });
        this.setState({ loading: false });
      })
      .catch(() => {
        notification.error({
          message: "Oops. Something went wrong. Please try again later.",
          description: "Please contact support if the issue persists.",
          duration: 0,
          key: "find-prior-art-by-patent"
        });
        this.setState({ loading: false });
      });
  };
}

export default withRouter(PriorArtLink);
